// service-transactions.js

import moment from "moment";
import { createSelector } from "reselect";

import { entityFactory } from "./entity";
import { encodeUrl } from "../helpers/fetch.js";

const fetchActionCreator = type => {
  return (start, end, length, orgId, svcId, sortBy, sortOrder) => {
    return {
      type,
      start,
      end,
      length,
      orgId,
      svcId,
      sortBy,
      sortOrder,
    };
  };
};

const urlCreator = action => {
  return encodeUrl(`/v1/apm/services/${action.svcId}/transactions`, {
    start_time: moment(action.start).unix(),
    end_time: moment(action.end).unix(),
    length: action.length,
    orderby: action.sortBy,
    sort: action.sortOrder,
  });
};

const { reducer, watcher, fetcher } = entityFactory(
  "transactions",
  fetchActionCreator,
  urlCreator,
  "transaction"
);

export default reducer;
export const serviceTransactionsWatcher = watcher;
export const fetchTransactions = fetcher;

// selectors
const getTransactionsByIds = state => state.entities.transactions.byId;
const getTransactionsAllIds = state => state.entities.transactions.allIds;

export const getTransactions = createSelector(
  [getTransactionsByIds, getTransactionsAllIds],
  (transactionsById, transactionsAllIds) =>
    transactionsAllIds.map(id => transactionsById[id])
);
